import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { isPreSale } from 'common/helpers/featureFlags';
import { getClubList } from 'common/helpers/miscHelper';
import ClubMembershipDisplay from 'profile/clubMembership/ClubMembershipDashboardDisplay';
import {
  getActiveClubMemberships,
  getHoldClubMemberships,
  getCancelledClubMemberships
} from 'redux/clubMemberships/reducers';

const ClubMemberships = (props) => {
  const { activeMemberships, onHoldMemberships, cancelledMemberships } = props;
  const { settings } = props;
  if (!activeMemberships) {
    return null;
  }
  const memberships = [
    ...activeMemberships,
    ...onHoldMemberships,
    ...cancelledMemberships
  ];
  const totalMemberships = memberships.length;
  const maxRows = 2;
  const moreNumber =
    totalMemberships > maxRows ? totalMemberships - maxRows : null;
  const displayArray = memberships.slice(0, maxRows);
  let title = 'Club Memberships';
  if (isPreSale()) {
    title = 'Pre-Sale Selection';
  }
  return (
    <div className="c7-account-tile">
      <h3>{title}</h3>
      {totalMemberships === 0 && (
        <>
          Join one of our clubs to experience club benefits today.
          <br />
          <br />
          <a href={`${getClubList(settings)}`} className="c7-button-small">
            Join a club
          </a>
        </>
      )}
      {displayArray.map((clubMembership) => (
        <div key={clubMembership.id} className="c7-account-tile__section">
          <ClubMembershipDisplay clubMembership={clubMembership} />
        </div>
      ))}
      <br />
      {renderMore(moreNumber)}
    </div>
  );
};

const mapStateToProps = (state) => ({
  activeMemberships: getActiveClubMemberships(state.clubMembership),
  onHoldMemberships: getHoldClubMemberships(state.clubMembership),
  cancelledMemberships: getCancelledClubMemberships(state.clubMembership),
  settings: state.setting
});

export default connect(mapStateToProps)(ClubMemberships);

const renderMore = (moreNumber) => {
  if (!moreNumber) {
    return null;
  }
  return (
    <Link to="/profile/club-membership" className="c7-button-small">
      View {moreNumber} more
    </Link>
  );
};
